/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssetsMelcoModelsError,
    AssetsMelcoModelsErrorFromJSON,
    AssetsMelcoModelsErrorToJSON,
    AssetsMelcoModelsGenericList1MelcoModelsSupplier,
    AssetsMelcoModelsGenericList1MelcoModelsSupplierFromJSON,
    AssetsMelcoModelsGenericList1MelcoModelsSupplierToJSON,
    AssetsMelcoModelsSupplier,
    AssetsMelcoModelsSupplierFromJSON,
    AssetsMelcoModelsSupplierToJSON,
} from '../models';

export interface ThreadSupplierApiAssetThreadSupplierGetRequest {
    id: string;
    publishState?: string;
}

export interface ThreadSupplierApiAssetThreadSupplierSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    name?: string;
    publishState?: string;
}

/**
 * 
 */
export class ThreadSupplierApi extends runtime.BaseAPI {

    /**
     */
    async assetThreadSupplierGetRaw(requestParameters: ThreadSupplierApiAssetThreadSupplierGetRequest): Promise<runtime.ApiResponse<AssetsMelcoModelsSupplier>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assetThreadSupplierGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assets/threads/suppliers/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsMelcoModelsSupplierFromJSON(jsonValue));
    }

    /**
     */
    async assetThreadSupplierGet(requestParameters: ThreadSupplierApiAssetThreadSupplierGetRequest): Promise<AssetsMelcoModelsSupplier> {
        const response = await this.assetThreadSupplierGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async assetThreadSupplierSearchRaw(requestParameters: ThreadSupplierApiAssetThreadSupplierSearchRequest): Promise<runtime.ApiResponse<AssetsMelcoModelsGenericList1MelcoModelsSupplier>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assets/threads/suppliers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetsMelcoModelsGenericList1MelcoModelsSupplierFromJSON(jsonValue));
    }

    /**
     */
    async assetThreadSupplierSearch(requestParameters: ThreadSupplierApiAssetThreadSupplierSearchRequest): Promise<AssetsMelcoModelsGenericList1MelcoModelsSupplier> {
        const response = await this.assetThreadSupplierSearchRaw(requestParameters);
        return await response.value();
    }

}
